import { Card, Grid, Button, Skeleton, Tooltip } from "@mui/material";
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import InboxOutlinedIcon from '@mui/icons-material/InboxOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import PaidOutlinedIcon from '@mui/icons-material/PaidOutlined';
import { useState, useEffect } from "react";
import ShowDeliveryMethod from "./showDeliveryMethod";
import { toStdDate } from "../../utils/dates";

export default function PendingBuyWaiting({ buyRequest, event, swarm, onCloseClick }) {

  const WaitingCell = ({ ts, createdOn }) => {
    //console.log('ts', ts)
    const [now, setNow] = useState(Date.now());
    useEffect(() => {
      const interval = setInterval(() => { setNow(Date.now()); }, 1000);
      return () => clearInterval(interval);
    }, []);

    if (ts === NaN || ts == null || isNaN(ts)) return 'Error';
    let hours = parseInt((Math.max(0, (now - ts)) / (60 * 60 * 1000)) % 60);
    let minutes = parseInt((Math.max(0, (now - ts)) / (60 * 1000)) % 60);
    let seconds = parseInt(Math.max(0, ((now - ts)) / (1000)) % 60);
    //Force 2 digits
    hours = hours.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
    minutes = minutes.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
    seconds = seconds.toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
    return (<>{`${minutes}:${seconds}`}</>)
  }

  const CardStyles = () => {
    return ({
      display: 'flex',
      flexDirection: { xs: 'column', sm: 'row', md: 'row', lg: 'row', xl: 'row' },
      alignItems: { xs: 'flex-end', sm: 'flex-end', md: 'flex-end', lg: 'center', xl: 'center' },
      justifyContent: 'space-between'
    });
  }

  const cardInfo = () => {
    return (
      {
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'column', md: 'column', lg: 'row', xl: 'row' },
        alignItems: 'flex-start',
        margin: { xs: '0 0 0.5em 0', sm: '0 0 0.5em 0', md: '0', lg: '0', xl: '0' }
      }
    );
  }

  const isMobile = useIsMobile();
  
  function useIsMobile(breakpoint = 600) {
  const [isMobile, setIsMobile] = useState(() => window.innerWidth < breakpoint);

    useEffect(() => {
      const handleResize = () => {
        setIsMobile(window.innerWidth < breakpoint);
      };
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, [breakpoint]);

    return isMobile;
  }

  let title = !event?.name ? "Error on Event Data" : `${event?.name} - ${event?.venue?.name + ", " + event?.venue?.city} - ${event ? toStdDate(event.date) : 'Null'}`;

  let mobileTitle = !event?.name ? "Error on Event Data" : `${event?.name?.substring(0, 20)} - ${event?.venue?.name?.substring(0, 20) + ", " + event?.venue?.city} - ${event ? toStdDate(event.date) : 'Null'}`;

  return (
    <Card sx={{ margin: '0  0 2em 0', borderRadius: '1.5em', padding: '1em' }} >

      <h4 style={{ fontWeight: '600', color: 'var(--orange)', margin: '0 0 0.5em 0 ' }} >
        {
          !event
            ?
            <Skeleton variant="text" width="50%" ></Skeleton>
            :
            <Tooltip title={title} placement="top" enterTouchDelay={0}>
              <span>{isMobile ? mobileTitle : title}</span>
            </Tooltip>
        }
      </h4>

      <Grid item xs={12} sx={CardStyles}>

        <Grid item sx={{ display: 'flex', flexDirection: 'column', width: '100%', }} >

          <Grid item sx={cardInfo} >
            <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', margin: '0 2em 0 0' }} >
              <ConfirmationNumberOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
              <p style={{ fontWeight: '700', margin: '0.15em 0 0 0' }} >{`${buyRequest.quantity} tickets in Section ${buyRequest.section} - Row ${buyRequest.row} - Seats ${buyRequest.seats}`}</p>
            </Grid>
            <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
              <InboxOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
              <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} > <ShowDeliveryMethod deliveryMethodID={buyRequest.deliveryMethodID} /></p>
            </Grid>
            <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', margin: '0 2em 0 0' }} >
              <SellOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
              <p style={{ fontWeight: '700', whiteSpace: 'nowrap', margin: '0.15em 0 0 0' }} >Total Cost ${buyRequest.totalCost}</p>
            </Grid>
            {
            buyRequest.isLimitedView &&
            <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
              <VisibilityOffOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
              <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} >Obstructed/Limited View</p>
            </Grid>
          }
            <Grid item sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', margin: '0 2em 0 0' }} >
              <PaidOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
              <p style={{ fontWeight: '700', whiteSpace: 'nowrap' }} >Reward {`$${buyRequest?.swarmRewardTypeId === 1 ? (buyRequest?.rewardAmout / buyRequest?.quantity) : buyRequest?.rewardAmout} ${buyRequest?.swarmRewardTypeId === 1 ? `Per Ticket` : `Total`}`}</p>
            </Grid>

          </Grid>

        </Grid>

        <Grid sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          <Grid sx={{ margin: '0 2em 0 0', display: 'flex', flexDirection: 'column', alignItems: 'center' }} >
            <h4 style={{ fontWeight: '600', color: 'var(--orange)', margin: '0 0 0.25em 0' }} >
              WAITING
            </h4>
            <Grid sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <TimerOutlinedIcon color='primary' sx={{ margin: '0 0.25em 0 0' }} />
              {/* This must be a timer that start once a users made a request */}
              <p style={{ fontSize: '1.25rem' }} ><WaitingCell createdOn={buyRequest.createdOn} ts={(buyRequest?.createdOn?.toLowerCase()?.endsWith('z') ?
                new Date(buyRequest.createdOn).valueOf() :
                new Date(buyRequest.createdOn + "Z").valueOf()
              )} /></p>
            </Grid>

          </Grid>

          <Button onClick={() => onCloseClick(buyRequest)} variant='contained' color="error" sx={{ borderRadius: '1em', padding: '0.75em', minWidth: '40px' }} >
            <CloseOutlinedIcon />
          </Button>
        </Grid>

      </Grid>

    </Card>
  )
}